// src/components/routing/ProtectedAdminRoute.tsx
import React, { useEffect } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext.tsx';
import { toast } from 'react-hot-toast';

const ProtectedAdminRoute: React.FC = () => {
  const { profile, loading, hasPermission } = useAuth();
  const navigate = useNavigate();

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
        <span className="ml-2">Admin paneli yükleniyor...</span>
      </div>
    );
  }
  
  // Yeni permission sistemi ile admin panel erişim kontrolü
  const hasAdminAccess = profile && hasPermission('admin_panel_access');

  useEffect(() => {
    if (!loading && profile && !hasAdminAccess) {
      toast.error("Admin paneline erişim yetkiniz bulunmamaktadır.");
      navigate('/anasayfa');
    }
    else if (!loading && !profile) {
      navigate('/auth/login');
    }
  }, [loading, profile, hasAdminAccess, navigate]);

  if (!hasAdminAccess) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-center">
          <h2 className="text-2xl font-bold text-red-600 mb-4">Erişim Reddedildi</h2>
          <p className="text-gray-600 mb-4">Admin paneline erişim yetkiniz bulunmamaktadır.</p>
          <button 
            onClick={() => navigate('/anasayfa')}
            className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
          >
            Ana Sayfaya Dön
          </button>
        </div>
      </div>
    );
  }

  return <Outlet />;
};

export default ProtectedAdminRoute;